module.exports = __webpack_public_path__ + "images/icons/icon-left-arrow-e71d2336.svg";